import React from 'react';
import { createRoot } from 'react-dom';
import App from './App';

createRoot(document.getElementById('root')).render(<App />);
